var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPearlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4796_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5449 2.20117C11.7229 1.8113 12.2771 1.8113 12.4551 2.20117L14.2207 6.07031C14.9703 7.71285 16.2872 9.02968 17.9297 9.7793L21.7988 11.5449C22.1887 11.7229 22.1887 12.2771 21.7988 12.4551L17.9297 14.2207C16.2872 14.9703 14.9703 16.2872 14.2207 17.9297L12.4551 21.7988C12.2771 22.1887 11.7229 22.1887 11.5449 21.7988L9.7793 17.9297C9.02968 16.2872 7.71285 14.9703 6.07031 14.2207L2.20117 12.4551C1.8113 12.2771 1.8113 11.7229 2.20117 11.5449L6.07031 9.7793C7.71285 9.02968 9.02968 7.71285 9.7793 6.07031L11.5449 2.20117Z",
    stroke: "#D62866"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4796_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearlLogo);
export default __webpack_public_path__ + "static/media/pearl-logo.37293bf8.svg";
export { ForwardRef as ReactComponent };